<div class="confirmation-modal">
    <ntv-modal
        [isVisible]="isVisible()"
        (modalClose)="onClose()"
        [modalHeight]="height()"
        [size]="size()"
        [showHeader]="false"
        [showFooter]="false">
        <div class="confirmation-modal">
            <div class="confirmation-modal__body">
                <!-- Icon Placeholder -->
                <div class="confirmation-modal__icon">
                    <div #lottieContainer></div>
                </div>

                <!-- Title and Message -->
                <div class="confirmation-modal__content">
                    <h1 class="confirmation-modal__title">{{ title() }}</h1>
                    <p class="confirmation-modal__message">{{ message() }}</p>
                </div>

                <!-- Optional Disclaimer / Note -->
                @if (disclaimer()) {
                    <div
                        class="confirmation-modal__disclaimer"
                        data-testid="confirmation-modal-disclaimer">
                        <svg
                            class="confirmation-modal__disclaimer-icon"
                            width="14"
                            height="14"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            aria-hidden="true">
                            <circle cx="12" cy="12" r="10"></circle>
                            <line x1="12" y1="16" x2="12" y2="12"></line>
                            <line x1="12" y1="8" x2="12.01" y2="8"></line>
                        </svg>
                        <p class="confirmation-modal__disclaimer-text">{{ disclaimer() }}</p>
                    </div>
                }

                <!-- Confirmation Input (delete-confirm) -->
                @if (type() === 'delete-confirm') {
                    <div
                        class="confirmation-modal__confirm-input"
                        data-testid="confirmation-modal-confirm-input">
                        @if (requiredText()) {
                            <p class="confirmation-modal__confirm-target">{{ requiredText() }}</p>
                        }
                        <input
                            type="text"
                            class="confirmation-modal__input"
                            [placeholder]="confirmInputPlaceholder()"
                            [ngModel]="typedValue()"
                            (ngModelChange)="onTypedValueChange($event)"
                            autocomplete="off" />
                    </div>
                }

                <!-- Action Buttons -->
                <div
                    class="confirmation-modal__actions"
                    [class.confirmation-modal__actions--single]="
                        (type() === 'success' || type() === 'error' || type() === 'warning') &&
                        !showCancelButton()
                    ">
                    @if (
                        type() === 'edit' ||
                        type() === 'delete' ||
                        type() === 'delete-confirm' ||
                        showCancelButton()
                    ) {
                        <ntv-button
                            [variant]="cancelVariant()"
                            size="xl"
                            (buttonClick)="onCancel()">
                            {{ cancelText() }}
                        </ntv-button>
                    }

                    <ntv-button
                        [variant]="'accent'"
                        size="xl"
                        [loading]="isLoading()"
                        [disabled]="isConfirmDisabled()"
                        (buttonClick)="onConfirm()">
                        {{ confirmText() }}
                    </ntv-button>
                </div>
            </div>
        </div>
    </ntv-modal>
</div>
